import { PAGE_CHANGED } from 'actions/globalActions'
import { byType } from 'rxOperators/byType'
import { consoleRelay } from 'components/features/webSocketLogger/ConsoleWSRelay'
import { Epic } from 'interfaces/middleware'
import { EMPTY } from 'rxjs'
import { mergeMap } from 'rxjs/operators'


export const wsLogsEpic: Epic = (action$) => action$.pipe(
  byType(PAGE_CHANGED),
  mergeMap((action) => {
    const isFromVideoPage = !!action.payload.prev?.match(/^(\/video|\/coaching\/)/) ?? false
    const isToVideoPage = !!action.payload.next.match(/^(\/video|\/coaching\/)/)

    if (consoleRelay.isStarted && isFromVideoPage && isToVideoPage) {
      consoleRelay.stop()
    }

    return EMPTY
  })
)
